export const COUNTRYOPTIONS = [
  { key: 'af', value: 'AF', flag: 'af', text: 'Afghanistan' },
  { key: 'ax', value: 'AX', flag: 'ax', text: 'Aland Islands' },
  { key: 'al', value: 'AL', flag: 'al', text: 'Albania' },
  { key: 'dz', value: 'DZ', flag: 'dz', text: 'Algeria' },
  { key: 'as', value: 'AS', flag: 'as', text: 'American Samoa' },
  { key: 'ad', value: 'AD', flag: 'ad', text: 'Andorra' },
  { key: 'ao', value: 'AO', flag: 'ao', text: 'Angola' },
  { key: 'ai', value: 'AI', flag: 'ai', text: 'Anguilla' },
  { key: 'ag', value: 'AG', flag: 'ag', text: 'Antigua' },
  { key: 'ar', value: 'AR', flag: 'ar', text: 'Argentina' },
  { key: 'am', value: 'AM', flag: 'am', text: 'Armenia' },
  { key: 'aw', value: 'AW', flag: 'aw', text: 'Aruba' },
  { key: 'au', value: 'AU', flag: 'au', text: 'Australia' },
  { key: 'at', value: 'AT', flag: 'at', text: 'Austria' },
  { key: 'az', value: 'AZ', flag: 'az', text: 'Azerbaijan' },
  { key: 'bs', value: 'BS', flag: 'bs', text: 'Bahamas' },
  { key: 'bh', value: 'BH', flag: 'bh', text: 'Bahrain' },
  { key: 'bd', value: 'BD', flag: 'bd', text: 'Bangladesh' },
  { key: 'bb', value: 'BB', flag: 'bb', text: 'Barbados' },
  { key: 'by', value: 'BY', flag: 'by', text: 'Belarus' },
  { key: 'be', value: 'BE', flag: 'be', text: 'Belgium' },
  { key: 'bz', value: 'BZ', flag: 'bz', text: 'Belize' },
  { key: 'bj', value: 'BJ', flag: 'bj', text: 'Benin' },
  { key: 'bm', value: 'BM', flag: 'bm', text: 'Bermuda' },
  { key: 'bt', value: 'BT', flag: 'bt', text: 'Bhutan' },
  { key: 'bo', value: 'BO', flag: 'bo', text: 'Bolivia' },
  { key: 'ba', value: 'BA', flag: 'ba', text: 'Bosnia' },
  { key: 'bw', value: 'BW', flag: 'bw', text: 'Botswana' },
  { key: 'bv', value: 'BV', flag: 'bv', text: 'Bouvet Island' },
  { key: 'br', value: 'BR', flag: 'br', text: 'Brazil' },
  { key: 'vg', value: 'VG', flag: 'vg', text: 'British Virgin Islands' },
  { key: 'bn', value: 'BN', flag: 'bn', text: 'Brunei' },
  { key: 'bg', value: 'BG', flag: 'bg', text: 'Bulgaria' },
  { key: 'bf', value: 'BF', flag: 'bf', text: 'Burkina Faso' },
  { key: 'bi', value: 'BI', flag: 'bi', text: 'Burundi' },
  { key: 'tc', value: 'TC', flag: 'tc', text: 'Caicos Islands' },
  { key: 'kh', value: 'KH', flag: 'kh', text: 'Cambodia' },
  { key: 'cm', value: 'CM', flag: 'cm', text: 'Cameroon' },
  { key: 'ca', value: 'CA', flag: 'ca', text: 'Canada' },
  { key: 'cv', value: 'CV', flag: 'cv', text: 'Cape Verde' },
  { key: 'ky', value: 'KY', flag: 'ky', text: 'Cayman Islands' },
  { key: 'cf', value: 'CF', flag: 'cf', text: 'Central African Republic' },
  { key: 'td', value: 'TD', flag: 'td', text: 'Chad' },
  { key: 'cl', value: 'CL', flag: 'cl', text: 'Chile' },
  { key: 'cn', value: 'CN', flag: 'cn', text: 'China' },
  { key: 'cx', value: 'CX', flag: 'cx', text: 'Christmas Island' },
  { key: 'cc', value: 'CC', flag: 'cc', text: 'Cocos Islands' },
  { key: 'co', value: 'CO', flag: 'co', text: 'Colombia' },
  { key: 'km', value: 'KM', flag: 'km', text: 'Comoros' },
  { key: 'cg', value: 'CG', flag: 'cg', text: 'Congo Brazzaville' },
  { key: 'cd', value: 'CD', flag: 'cd', text: 'Congo' },
  { key: 'ck', value: 'CK', flag: 'ck', text: 'Cook Islands' },
  { key: 'cr', value: 'CR', flag: 'cr', text: 'Costa Rica' },
  { key: 'ci', value: 'CI', flag: 'ci', text: 'Cote Divoire' },
  { key: 'hr', value: 'HR', flag: 'hr', text: 'Croatia' },
  { key: 'cu', value: 'CU', flag: 'cu', text: 'Cuba' },
  { key: 'cy', value: 'CY', flag: 'cy', text: 'Cyprus' },
  { key: 'cz', value: 'CZ', flag: 'cz', text: 'Czech Republic' },
  { key: 'dk', value: 'DK', flag: 'dk', text: 'Denmark' },
  { key: 'dj', value: 'DJ', flag: 'dj', text: 'Djibouti' },
  { key: 'dm', value: 'DM', flag: 'dm', text: 'Dominica' },
  { key: 'do', value: 'DO', flag: 'do', text: 'Dominican Republic' },
  { key: 'ec', value: 'EC', flag: 'ec', text: 'Ecuador' },
  { key: 'eg', value: 'EG', flag: 'eg', text: 'Egypt' },
  { key: 'sv', value: 'SV', flag: 'sv', text: 'El Salvador' },
  { key: 'gb', value: 'GB', flag: 'gb', text: 'England' },
  { key: 'gq', value: 'GQ', flag: 'gq', text: 'Equatorial Guinea' },
  { key: 'er', value: 'ER', flag: 'er', text: 'Eritrea' },
  { key: 'ee', value: 'EE', flag: 'ee', text: 'Estonia' },
  { key: 'et', value: 'ET', flag: 'et', text: 'Ethiopia' },
  { key: 'eu', value: 'EU', flag: 'eu', text: 'European Union' },
  { key: 'fk', value: 'FK', flag: 'fk', text: 'Falkland Islands' },
  { key: 'fo', value: 'FO', flag: 'fo', text: 'Faroe Islands' },
  { key: 'fj', value: 'FJ', flag: 'fj', text: 'Fiji' },
  { key: 'fi', value: 'FI', flag: 'fi', text: 'Finland' },
  { key: 'fr', value: 'FR', flag: 'fr', text: 'France' },
  { key: 'gf', value: 'GF', flag: 'gf', text: 'French Guiana' },
  { key: 'pf', value: 'PF', flag: 'pf', text: 'French Polynesia' },
  { key: 'tf', value: 'TF', flag: 'tf', text: 'French Territories' },
  { key: 'ga', value: 'GA', flag: 'ga', text: 'Gabon' },
  { key: 'gm', value: 'GM', flag: 'gm', text: 'Gambia' },
  { key: 'ge', value: 'GE', flag: 'ge', text: 'Georgia' },
  { key: 'de', value: 'DE', flag: 'de', text: 'Germany' },
  { key: 'gh', value: 'GH', flag: 'gh', text: 'Ghana' },
  { key: 'gi', value: 'GI', flag: 'gi', text: 'Gibraltar' },
  { key: 'gr', value: 'GR', flag: 'gr', text: 'Greece' },
  { key: 'gl', value: 'GL', flag: 'gl', text: 'Greenland' },
  { key: 'gd', value: 'GD', flag: 'gd', text: 'Grenada' },
  { key: 'gp', value: 'GP', flag: 'gp', text: 'Guadeloupe' },
  { key: 'gu', value: 'GU', flag: 'gu', text: 'Guam' },
  { key: 'gt', value: 'GT', flag: 'gt', text: 'Guatemala' },
  { key: 'gw', value: 'GW', flag: 'gw', text: 'Guinea-Bissau' },
  { key: 'gn', value: 'GN', flag: 'gn', text: 'Guinea' },
  { key: 'gy', value: 'GY', flag: 'gy', text: 'Guyana' },
  { key: 'ht', value: 'HT', flag: 'ht', text: 'Haiti' },
  { key: 'hm', value: 'HM', flag: 'hm', text: 'Heard Island' },
  { key: 'hn', value: 'HN', flag: 'hn', text: 'Honduras' },
  { key: 'hk', value: 'HK', flag: 'hk', text: 'Hong Kong' },
  { key: 'hu', value: 'HU', flag: 'hu', text: 'Hungary' },
  { key: 'is', value: 'IS', flag: 'is', text: 'Iceland' },
  { key: 'in', value: 'IN', flag: 'in', text: 'India' },
  { key: 'io', value: 'IO', flag: 'io', text: 'Indian Ocean Territory' },
  { key: 'id', value: 'ID', flag: 'id', text: 'Indonesia' },
  { key: 'ir', value: 'IR', flag: 'ir', text: 'Iran' },
  { key: 'iq', value: 'IQ', flag: 'iq', text: 'Iraq' },
  { key: 'ie', value: 'IE', flag: 'ie', text: 'Ireland' },
  { key: 'il', value: 'IL', flag: 'il', text: 'Israel' },
  { key: 'it', value: 'IT', flag: 'it', text: 'Italy' },
  { key: 'jm', value: 'JM', flag: 'jm', text: 'Jamaica' },
  { key: 'jp', value: 'JP', flag: 'jp', text: 'Japan' },
  { key: 'jo', value: 'JO', flag: 'jo', text: 'Jordan' },
  { key: 'kz', value: 'KZ', flag: 'kz', text: 'Kazakhstan' },
  { key: 'ke', value: 'KE', flag: 'ke', text: 'Kenya' },
  { key: 'ki', value: 'KI', flag: 'ki', text: 'Kiribati' },
  { key: 'kw', value: 'KW', flag: 'kw', text: 'Kuwait' },
  { key: 'kg', value: 'KG', flag: 'kg', text: 'Kyrgyzstan' },
  { key: 'la', value: 'LA', flag: 'la', text: 'Laos' },
  { key: 'lv', value: 'LV', flag: 'lv', text: 'Latvia' },
  { key: 'lb', value: 'LB', flag: 'lb', text: 'Lebanon' },
  { key: 'ls', value: 'LS', flag: 'ls', text: 'Lesotho' },
  { key: 'lr', value: 'LR', flag: 'lr', text: 'Liberia' },
  { key: 'ly', value: 'LY', flag: 'ly', text: 'Libya' },
  { key: 'li', value: 'LI', flag: 'li', text: 'Liechtenstein' },
  { key: 'lt', value: 'LT', flag: 'lt', text: 'Lithuania' },
  { key: 'lu', value: 'LU', flag: 'lu', text: 'Luxembourg' },
  { key: 'mo', value: 'MO', flag: 'mo', text: 'Macau' },
  { key: 'mk', value: 'MK', flag: 'mk', text: 'Macedonia' },
  { key: 'mg', value: 'MG', flag: 'mg', text: 'Madagascar' },
  { key: 'mw', value: 'MW', flag: 'mw', text: 'Malawi' },
  { key: 'my', value: 'MY', flag: 'my', text: 'Malaysia' },
  { key: 'mv', value: 'MV', flag: 'mv', text: 'Maldives' },
  { key: 'ml', value: 'ML', flag: 'ml', text: 'Mali' },
  { key: 'mt', value: 'MT', flag: 'mt', text: 'Malta' },
  { key: 'mh', value: 'MH', flag: 'mh', text: 'Marshall Islands' },
  { key: 'mq', value: 'MQ', flag: 'mq', text: 'Martinique' },
  { key: 'mr', value: 'MR', flag: 'mr', text: 'Mauritania' },
  { key: 'mu', value: 'MU', flag: 'mu', text: 'Mauritius' },
  { key: 'yt', value: 'YT', flag: 'yt', text: 'Mayotte' },
  { key: 'mx', value: 'MX', flag: 'mx', text: 'Mexico' },
  { key: 'fm', value: 'FM', flag: 'fm', text: 'Micronesia' },
  { key: 'md', value: 'MD', flag: 'md', text: 'Moldova' },
  { key: 'mc', value: 'MC', flag: 'mc', text: 'Monaco' },
  { key: 'mn', value: 'MN', flag: 'mn', text: 'Mongolia' },
  { key: 'me', value: 'ME', flag: 'me', text: 'Montenegro' },
  { key: 'ms', value: 'MS', flag: 'ms', text: 'Montserrat' },
  { key: 'ma', value: 'MA', flag: 'ma', text: 'Morocco' },
  { key: 'mz', value: 'MZ', flag: 'mz', text: 'Mozambique' },
  { key: 'na', value: 'NA', flag: 'na', text: 'Namibia' },
  { key: 'nr', value: 'NR', flag: 'nr', text: 'Nauru' },
  { key: 'np', value: 'NP', flag: 'np', text: 'Nepal' },
  { key: 'an', value: 'AN', flag: 'an', text: 'Netherlands Antilles' },
  { key: 'nl', value: 'NL', flag: 'nl', text: 'Netherlands' },
  { key: 'nc', value: 'NC', flag: 'nc', text: 'New Caledonia' },
  { key: 'pg', value: 'PG', flag: 'pg', text: 'New Guinea' },
  { key: 'nz', value: 'NZ', flag: 'nz', text: 'New Zealand' },
  { key: 'ni', value: 'NI', flag: 'ni', text: 'Nicaragua' },
  { key: 'ne', value: 'NE', flag: 'ne', text: 'Niger' },
  { key: 'ng', value: 'NG', flag: 'ng', text: 'Nigeria' },
  { key: 'nu', value: 'NU', flag: 'nu', text: 'Niue' },
  { key: 'nf', value: 'NF', flag: 'nf', text: 'Norfolk Island' },
  { key: 'kp', value: 'KP', flag: 'kp', text: 'North Korea' },
  { key: 'mp', value: 'MP', flag: 'mp', text: 'Northern Mariana Islands' },
  { key: 'no', value: 'NO', flag: 'no', text: 'Norway' },
  { key: 'om', value: 'OM', flag: 'om', text: 'Oman' },
  { key: 'pk', value: 'PK', flag: 'pk', text: 'Pakistan' },
  { key: 'pw', value: 'PW', flag: 'pw', text: 'Palau' },
  { key: 'ps', value: 'PS', flag: 'ps', text: 'Palestine' },
  { key: 'pa', value: 'PA', flag: 'pa', text: 'Panama' },
  { key: 'py', value: 'PY', flag: 'py', text: 'Paraguay' },
  { key: 'pe', value: 'PE', flag: 'pe', text: 'Peru' },
  { key: 'ph', value: 'PH', flag: 'ph', text: 'Philippines' },
  { key: 'pn', value: 'PN', flag: 'pn', text: 'Pitcairn Islands' },
  { key: 'pl', value: 'PL', flag: 'pl', text: 'Poland' },
  { key: 'pt', value: 'PT', flag: 'pt', text: 'Portugal' },
  { key: 'pr', value: 'PR', flag: 'pr', text: 'Puerto Rico' },
  { key: 'qa', value: 'QA', flag: 'qa', text: 'Qatar' },
  { key: 're', value: 'RE', flag: 're', text: 'Reunion' },
  { key: 'ro', value: 'RO', flag: 'ro', text: 'Romania' },
  { key: 'ru', value: 'RU', flag: 'ru', text: 'Russia' },
  { key: 'rw', value: 'RW', flag: 'rw', text: 'Rwanda' },
  { key: 'sh', value: 'SH', flag: 'sh', text: 'Saint Helena' },
  { key: 'kn', value: 'KN', flag: 'kn', text: 'Saint Kitts and Nevis' },
  { key: 'lc', value: 'LC', flag: 'lc', text: 'Saint Lucia' },
  { key: 'pm', value: 'PM', flag: 'pm', text: 'Saint Pierre' },
  { key: 'vc', value: 'VC', flag: 'vc', text: 'Saint Vincent' },
  { key: 'ws', value: 'WS', flag: 'ws', text: 'Samoa' },
  { key: 'sm', value: 'SM', flag: 'sm', text: 'San Marino' },
  { key: 'gs', value: 'GS', flag: 'gs', text: 'Sandwich Islands' },
  { key: 'st', value: 'ST', flag: 'st', text: 'Sao Tome' },
  { key: 'sa', value: 'SA', flag: 'sa', text: 'Saudi Arabia' },
  { key: 'sn', value: 'SN', flag: 'sn', text: 'Senegal' },
  { key: 'cs', value: 'CS', flag: 'cs', text: 'Czechoslovakia' },
  { key: 'rs', value: 'RS', flag: 'rs', text: 'Serbia' },
  { key: 'sc', value: 'SC', flag: 'sc', text: 'Seychelles' },
  { key: 'sl', value: 'SL', flag: 'sl', text: 'Sierra Leone' },
  { key: 'sg', value: 'SG', flag: 'sg', text: 'Singapore' },
  { key: 'sk', value: 'SK', flag: 'sk', text: 'Slovakia' },
  { key: 'si', value: 'SI', flag: 'si', text: 'Slovenia' },
  { key: 'sb', value: 'SB', flag: 'sb', text: 'Solomon Islands' },
  { key: 'so', value: 'SO', flag: 'so', text: 'Somalia' },
  { key: 'za', value: 'ZA', flag: 'za', text: 'South Africa' },
  { key: 'kr', value: 'KR', flag: 'kr', text: 'South Korea' },
  { key: 'es', value: 'ES', flag: 'es', text: 'Spain' },
  { key: 'lk', value: 'LK', flag: 'lk', text: 'Sri Lanka' },
  { key: 'sd', value: 'SD', flag: 'sd', text: 'Sudan' },
  { key: 'sr', value: 'SR', flag: 'sr', text: 'Suriname' },
  { key: 'sj', value: 'SJ', flag: 'sj', text: 'Svalbard' },
  { key: 'sz', value: 'SZ', flag: 'sz', text: 'Swaziland' },
  { key: 'se', value: 'SE', flag: 'se', text: 'Sweden' },
  { key: 'ch', value: 'CH', flag: 'ch', text: 'Switzerland' },
  { key: 'sy', value: 'SY', flag: 'sy', text: 'Syria' },
  { key: 'tw', value: 'TW', flag: 'tw', text: 'Taiwan' },
  { key: 'tj', value: 'TJ', flag: 'tj', text: 'Tajikistan' },
  { key: 'tz', value: 'TZ', flag: 'tz', text: 'Tanzania' },
  { key: 'th', value: 'TH', flag: 'th', text: 'Thailand' },
  { key: 'tl', value: 'TL', flag: 'tl', text: 'Timorleste' },
  { key: 'tg', value: 'TG', flag: 'tg', text: 'Togo' },
  { key: 'tk', value: 'TK', flag: 'tk', text: 'Tokelau' },
  { key: 'to', value: 'TO', flag: 'to', text: 'Tonga' },
  { key: 'tt', value: 'TT', flag: 'tt', text: 'Trinidad' },
  { key: 'tn', value: 'TN', flag: 'tn', text: 'Tunisia' },
  { key: 'tr', value: 'TR', flag: 'tr', text: 'Turkey' },
  { key: 'tm', value: 'TM', flag: 'tm', text: 'Turkmenistan' },
  { key: 'tv', value: 'TV', flag: 'tv', text: 'Tuvalu' },
  { key: 'ug', value: 'UG', flag: 'ug', text: 'Uganda' },
  { key: 'ua', value: 'UA', flag: 'ua', text: 'Ukraine' },
  { key: 'ae', value: 'AE', flag: 'ae', text: 'United Arab Emirates' },
  { key: 'us', value: 'US', flag: 'us', text: 'United States' },
  { key: 'uy', value: 'UY', flag: 'uy', text: 'Uruguay' },
  { key: 'um', value: 'UM', flag: 'um', text: 'Us Minor Islands' },
  { key: 'vi', value: 'VI', flag: 'vi', text: 'Us Virgin Islands' },
  { key: 'uz', value: 'UZ', flag: 'uz', text: 'Uzbekistan' },
  { key: 'vu', value: 'VU', flag: 'vu', text: 'Vanuatu' },
  { key: 'va', value: 'VA', flag: 'va', text: 'Vatican City' },
  { key: 've', value: 'VE', flag: 've', text: 'Venezuela' },
  { key: 'vn', value: 'VN', flag: 'vn', text: 'Vietnam' },
  { key: 'wf', value: 'WF', flag: 'wf', text: 'Wallis and Futuna' },
  { key: 'eh', value: 'EH', flag: 'eh', text: 'Western Sahara' },
  { key: 'ye', value: 'YE', flag: 'ye', text: 'Yemen' },
  { key: 'zm', value: 'ZM', flag: 'zm', text: 'Zambia' },
  { key: 'zw', value: 'ZW', flag: 'zw', text: 'Zimbabwe' }
]
